let expected = 0
let timeout = 0
let interval = 0
let totalSteps = 0
let remainingSteps = 0
let info = {}
let forever = false
let running = false

const neverEnd = function() {
	forever = true
}

const setInfo = function (x) {
	info = x
}

const setTotalSteps = function (x) {
	totalSteps = x
}

const setRemainingSteps = function (x) {
	remainingSteps = x
}

const setInterval = function (x) {
	interval = x
}

const start = function () {
	if (running) return
	running = true
	expected = Date.now() + interval
	timeout = setTimeout(step, interval)
}

const stop = function () {
	clearTimeout(timeout)
	running = false
}

const step = function () {
	if (!running) return
	const drift = Date.now() - expected
	if (drift > interval) {}
	expected += interval
	timeout = setTimeout(step, Math.max(0, interval - drift))
	remainingSteps -= 1
	postMessage({ msg: 'Remaining Steps', remainingSteps, info })
	if (!forever && remainingSteps === 0) stop()
}

onmessage = function({ data: { cmd, data = null } }) {
	const functions = {
		start,
		stop,
		setTotalSteps,
		setInterval,
		setRemainingSteps,
		setInfo,
		neverEnd
	}
	if (functions[cmd]) functions[cmd](data)
}
